import React from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  SquaresPlusIcon,
  CursorArrowRaysIcon,
} from '@heroicons/react/24/outline';
import { EmptyState } from '../../../components/ui';
import NoItems from '../../../assets/no-items.svg';

const isEmptyChannelData = (data) =>
  data.length === 1 &&
  data[0].terminal === 'Online' &&
  data[0].id === 'Online' &&
  data[0].count === 0;

const OrderChannelsPanel = ({ orderInformations, pieChart }) => {
  const empty = isEmptyChannelData(
    orderInformations.orderCountByTerminal || [],
  );

  return (
    <section className="reveal flex h-full flex-col overflow-hidden rounded-md border border-slate-200 bg-white p-5 dark:border-slate-700 dark:bg-slate-800/70">
      <div>
        <div className="flex items-center gap-3">
          <SquaresPlusIcon
            className="h-6 w-6 text-slate-900 dark:text-slate-100"
            aria-hidden
          />
          <h3 className="text-base font-bold text-slate-900 dark:text-slate-100">
            Order Channels
          </h3>
        </div>
        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
          See your popular ordering channels.
        </p>
      </div>

      <div className="mt-4 flex min-h-[260px] items-center justify-center">
        {empty ? (
          <EmptyState variant="plain" image={NoItems} title="No channel data" />
        ) : (
          <ReactApexChart
            options={pieChart.chartOptions}
            series={pieChart.series}
            type="pie"
            height={300}
          />
        )}
      </div>

      <div className="mt-4 flex flex-1 flex-col items-center justify-center pt-5 text-center">
        <div className="flex items-center justify-center gap-2">
          <CursorArrowRaysIcon className="h-4 w-4 text-slate-900 dark:text-slate-100" />
          <p className="text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
            Customer Interactions
          </p>
        </div>
        <span className="mt-3 tabular-nums text-4xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-5xl">
          {Number(orderInformations.totalClickCount || 0).toLocaleString(
            'en-US',
          )}
        </span>
        <span className="mt-1 text-xs text-slate-500 dark:text-slate-400">
          customers interacted with the kiosk
        </span>
      </div>
    </section>
  );
};

export default OrderChannelsPanel;
